import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSchool: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSchool"><Path d="M21.5 19.5V8.5H17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 19.5V4.5H6.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 8.5H2.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M22.5 19.5H1.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 19.5V15.5H14.5V19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSchool;
